<template>
  <div v-if="over">
    <div class="email_result" v-if="!result">
      <van-icon name="clear" color="#f51c21" />
      <p class="title">抱歉！激活失败</p>
      <p>{{ message }}</p>
    </div>
    <div class="email_result" v-else>
      <van-icon name="checked" color="#52c41a" />
      <p class="title">恭喜！激活成功</p>
      <p>{{ message }}</p>
    </div>
  </div>
</template>

<script>
import { getUrlKey } from 'utils/common.js'
import { checkUserEmail } from 'api/user/auth/login'

export default {
  data() {
    return {
      over: false,
      result: true,
      message: '',
      email_form: {
        email: getUrlKey("email", window.location.href),
        user_id: this.$route.params.user_id,
        captcha: this.$route.params.captcha
      }
    }
  },
  mounted() {
    this.$emit('update:isShowHeader', true);
    this.confirmEmail();
  },
  methods: {
    confirmEmail() {
      let that = this;
      checkUserEmail(this.email_form).then((res) => {
        that.message = res.msg;
        that.result = res.result === 0 ? true : false;
        that.over = true;
      }).catch(error => {

      });
    }
  }
}

</script>

<style lang="scss" scoped>
  .email_result {
    padding-top:120px;
    text-align: center;
    i {
      font-size:48px;
      margin-bottom:40px;
    }
    p {
      margin-top:0;
      margin-bottom:30px;
      font-size:15px;
      &.title {
        font-size:21px;
      }
    }
  }
</style>
